import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DSIcon } from '@spotahome/ui-library/base';

import './NavigationAngle.scss';

const noop = () => {};

const NavigationAngle = ({ onClick = noop, side = 'left', className = '' }) => (
  <div
    className={classNames(
      'navigation-angle',
      `navigation-angle--${side}`,
      className
    )}
    onClick={onClick}
    role="button"
    tabIndex="0"
  >
    <DSIcon name={`arrow_full_${side}`} size="l" />
  </div>
);

NavigationAngle.propTypes = {
  onClick: PropTypes.func,
  side: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string
};

export default NavigationAngle;
